<template>
  <v-dialog :retain-focus="false" :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text>
        <div class="mb-4">
          <label class="label-input">Section Name</label>
          <v-text-field v-model="fields.title" hide-details />
        </div>

        <div class="mb-5">
          <label class="label-input">Layout</label>
          <div class="group-item">
            <v-row>
              <v-col cols="12">
                <label>Background Image</label>
                <UploadImage
                  :image="{ imageSrc: fields.settings.backgroundImage }"
                  :height="`140`"
                  :typeUpload="'image'"
                  @callback="obj => handleUploadBackgroundImage(obj)"
                  @callbackDelete="handleRemoveBackgroundImage"
                />
              </v-col>
              <v-col cols="12" md="6">
                <label>Background Color</label>
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    v-model="fields.settings.backgroundColor"
                  />
                  <v-text-field v-model="fields.settings.backgroundColor" hide-details class="mt-0" />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <label>Text Color</label>
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    v-model="fields.settings.textColor"
                  />
                  <v-text-field v-model="fields.settings.textColor" hide-details class="mt-0" />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <v-checkbox v-model="fields.settings.paddingTop" label="Top Padding" hide-details class="mt-0" />
              </v-col>
              <v-col cols="12" md="6">
                <v-checkbox v-model="fields.settings.paddingBottom" label="Bottom Padding" hide-details class="mt-0" />
              </v-col>
              <v-col cols="12" md="12">
                <v-checkbox v-model="fields.settings.showOverlay" label="Show Overlay" hide-details class="mt-0 mb-2" />
                <v-row v-if="fields.settings.showOverlay">
                  <v-col cols="12" md="6">
                    <label>Overlay Color</label>
                    <div class="d-flex align-center gap-3">
                      <input
                        type="color"
                        style="width: 40px; height: 40px; margin-right: 12px"
                        v-model="fields.settings.overlayColor"
                      />
                      <v-text-field v-model="fields.settings.overlayColor" hide-details class="mt-0" />
                    </div>
                  </v-col>
                  <v-col cols="12" md="6">
                    <label>Overlay Opacity (0 - 1)</label>
                    <v-text-field
                      v-model.number="fields.settings.overlayOpacity"
                      type="number"
                      step="0.1"
                      hide-details
                      class="mt-0"
                    />
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" md="12">
                <v-checkbox
                  v-model="fields.containerPage.enableStyle"
                  label="Enable Style Container"
                  hide-details
                  class="mt-0 mb-2"
                />
                <div v-if="fields.containerPage.enableStyle">
                  <label>Container Background</label>
                  <div class="d-flex align-center gap-3">
                    <input
                      type="color"
                      style="width: 40px; height: 40px; margin-right: 12px"
                      v-model="fields.containerPage.background"
                    />
                    <v-text-field v-model="fields.containerPage.background" hide-details class="mt-0" />
                  </div>
                </div>
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="mb-5">
          <label class="label-input">Title Section</label>
          <div class="group-item">
            <v-checkbox v-model="fields.titleCard.show" label="Show title block" hide-details class="mt-0 mb-2" />
            <ckeditor
              v-if="fields.titleCard.show"
              :editor="editor"
              v-model="fields.titleCard.content"
              :config="editorConfig"
            />
          </div>
        </div>

        <div class="mb-5">
          <label class="label-input">Tabs settings</label>
          <div class="group-item">
            <div>
              <div>Tab Navigation</div>
              <div class="group-item">
                <v-row>
                  <v-col cols="12" md="6">
                    <div>
                      <label>Color</label>
                      <div class="d-flex align-center gap-3">
                        <input
                          type="color"
                          style="width: 40px; height: 40px; margin-right: 12px"
                          v-model="fields.listTabNav.navColor"
                        />
                        <v-text-field v-model="fields.listTabNav.navColor" hide-details class="mt-0" />
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="12" md="6">
                    <div>
                      <label>Background</label>
                      <div class="d-flex align-center gap-3">
                        <input
                          type="color"
                          style="width: 40px; height: 40px; margin-right: 12px"
                          v-model="fields.listTabNav.navBackground"
                        />
                        <v-text-field v-model="fields.listTabNav.navBackground" hide-details class="mt-0" />
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="12" md="6">
                    <div>
                      <label>Border Radius (px)</label>
                      <v-text-field
                        v-model.number="fields.listTabNav.navBorderRadius"
                        type="number"
                        hide-details
                        class="mt-0"
                      />
                    </div>
                  </v-col>
                  <v-col cols="12" md="6">
                    <div>
                      <label>Active Color</label>
                      <div class="d-flex align-center gap-3">
                        <input
                          type="color"
                          style="width: 40px; height: 40px; margin-right: 12px"
                          v-model="fields.listTabNav.activeNavColor"
                        />
                        <v-text-field v-model="fields.listTabNav.activeNavColor" hide-details class="mt-0" />
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="12" md="6">
                    <div>
                      <label>Active Background</label>
                      <div class="d-flex align-center gap-3">
                        <input
                          type="color"
                          style="width: 40px; height: 40px; margin-right: 12px"
                          v-model="fields.listTabNav.activeNavBackground"
                        />
                        <v-text-field v-model="fields.listTabNav.activeNavBackground" hide-details class="mt-0" />
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </div>
            </div>
            <div>
              <div>Tab Content</div>
              <div class="group-item">
                <v-row>
                  <v-col cols="12" md="4">
                    <label>Column Per View</label>
                    <v-select
                      v-model="fields.listTabContent.colPerView"
                      :items="[1, 2, 3, 4, 5, 6]"
                      hide-details
                      class="mt-0"
                    />
                  </v-col>
                  <v-col cols="12" md="4">
                    <label>Space Between (px)</label>
                    <v-text-field
                      v-model.number="fields.listTabContent.spaceBetween"
                      type="number"
                      hide-details
                      class="mt-0"
                    />
                  </v-col>
                  <v-col cols="12" md="4">
                    <label>Border Radius (px)</label>
                    <v-text-field
                      v-model.number="fields.listTabContent.borderRadius"
                      type="number"
                      hide-details
                      class="mt-0"
                    />
                  </v-col>
                  <v-col cols="12" md="4">
                    <label>Item Background</label>
                    <div class="d-flex align-center gap-3">
                      <input
                        type="color"
                        style="width: 40px; height: 40px; margin-right: 12px"
                        v-model="fields.listTabContent.background"
                      />
                      <v-text-field v-model="fields.listTabContent.background" hide-details class="mt-0" />
                    </div>
                  </v-col>
                  <v-col cols="12" md="4">
                    <label>Item Border Color</label>
                    <div class="d-flex align-center gap-3">
                      <input
                        type="color"
                        style="width: 40px; height: 40px; margin-right: 12px"
                        v-model="fields.listTabContent.border"
                      />
                      <v-text-field v-model="fields.listTabContent.border" hide-details class="mt-0" />
                    </div>
                  </v-col>
                  <v-col cols="12" md="4">
                    <div>
                      <label>Item Color</label>
                      <div class="d-flex align-center gap-3">
                        <input
                          type="color"
                          style="width: 40px; height: 40px; margin-right: 12px"
                          v-model="fields.listTabContent.colorItem"
                        />
                        <v-text-field v-model="fields.listTabContent.colorItem" hide-details class="mt-0" />
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </div>
            </div>
          </div>
        </div>

        <div class="mb-5">
          <label class="label-input">Tabs</label>
          <div class="group-item">
            <div class="d-flex justify-end mb-2">
              <v-btn small color="primary" @click="handleAddTab">
                <v-icon size="16">mdi-plus</v-icon>
                <span>Add Tab</span>
              </v-btn>
            </div>
            <v-expansion-panels accordion>
              <v-expansion-panel v-for="(tab, ti) in fields.tabs" :key="`tab-${ti}`">
                <v-expansion-panel-header>
                  <div class="d-flex justify-space-between align-center" style="width: 100%">
                    <span>
                      Tab {{ ti + 1 }} -
                      <strong>{{ tab.label }}</strong>
                      <span v-if="tab.active" class="ml-2" style="color: #0081c7">(default)</span>
                    </span>
                    <v-btn icon @click.stop="handleRemoveTab(ti)">
                      <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row>
                    <v-col cols="12">
                      <label>Label</label>
                      <v-text-field v-model="tab.label" hide-details class="mt-0" />
                    </v-col>

                    <v-col cols="12">
                      <v-checkbox
                        :input-value="tab.active"
                        label="Active by default"
                        hide-details
                        class="mt-0"
                        @change="handleSetActiveTab(ti)"
                      />
                    </v-col>
                  </v-row>

                  <div class="d-flex justify-space-between align-center mt-3 mb-2">
                    <strong>Reviews</strong>
                    <v-btn small color="primary" @click="handleAddReview(ti)">
                      <v-icon size="16">mdi-plus</v-icon>
                      <span>Add Review</span>
                    </v-btn>
                  </div>
                  <v-expansion-panels accordion>
                    <v-expansion-panel v-for="(review, ri) in tab.reviews" :key="`tab-${ti}-review-${ri}`">
                      <v-expansion-panel-header>
                        <div class="d-flex justify-space-between align-center">
                          <span>Review {{ ri + 1 }} - {{ review.username || '—' }}</span>
                          <v-btn icon @click.stop="handleRemoveReview(ti, ri)">
                            <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                          </v-btn>
                        </div>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <div class="mb-4">
                          <UploadImage
                            @callback="obj => handleUploadAvatar(obj, ti, ri)"
                            :image="{ imageSrc: review.avatar }"
                            :height="`140`"
                            :typeUpload="'image'"
                            @callbackDelete="handleRemoveAvatar(ti, ri)"
                          />
                        </div>
                        <div class="mb-4">
                          <label>Username</label>
                          <v-text-field v-model="review.username" hide-details class="mt-0" />
                        </div>
                        <div class="mb-4">
                          <label>Review Content</label>
                          <ckeditor :editor="editor" v-model="review.review" :config="editorConfig" />
                        </div>
                        <div class="mb-2">
                          <v-checkbox v-model="review.verifiedShow" label="Show verified" hide-details class="mt-0" />
                        </div>
                        <template v-if="review.verifiedShow">
                          <div class="mb-4">
                            <UploadImage
                              @callback="obj => handleUploadVerifiedIcon(obj, ti, ri)"
                              :image="{ imageSrc: review.verifiedIcon }"
                              :height="`80`"
                              :typeUpload="'image'"
                              @callbackDelete="handleRemoveVerifiedIcon(ti, ri)"
                            />
                          </div>
                          <div class="mb-4">
                            <label>Verified Text</label>
                            <v-text-field v-model="review.verifiedText" hide-details class="mt-0" />
                          </div>
                        </template>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import { updateHtmlFromData } from '../common/html/update';
import UploadImage from '../common/form/upload-file/upload-image.vue';

const DEFAULT_VERIFIED_ICON =
  'https://cdn.skyfastimg.com/6a0ee559dc2c2e000934dd37/2026/05/26/image-6a1503ecf7611bb29b1212e7.png?w=50&h=50&q=80';

const buildDefaultReview = () => ({
  review: '<p></p>',
  avatar: '',
  username: '',
  verifiedShow: true,
  verifiedIcon: DEFAULT_VERIFIED_ICON,
  verifiedText: 'Verified Buyer',
});

const getDefaultFields = () => ({
  title: 'Card With Tabs Boxer Section',
  settings: {
    paddingTop: true,
    paddingBottom: true,
    backgroundColor: '#FFFFFF',
    textColor: '#000000',
    overlayColor: '#000000',
    overlayOpacity: 0,
    showOverlay: false,
    backgroundImage: '',
  },
  containerPage: {
    enableStyle: false,
    background: '#FFFFFF',
  },
  titleCard: {
    show: true,
    content:
      '<h2 style="text-align: center;">What Men Say After Switching</h2><p style="text-align: center;">Thousands of men have already made the switch.</p>',
  },
  listTabNav: {
    navColor: '#606F99',
    navBackground: '#ffffff',
    navBorderRadius: 5,
    activeNavColor: '#ffffff',
    activeNavBackground: '#606F99',
  },
  listTabContent: {
    colPerView: 4,
    spaceBetween: 30,
    borderRadius: 0,
    background: '#ffffff',
    border: '#eff3fa',
    colorItem: '#000000',
  },
  tabs: [
    {
      key: 'tab-1',
      label: 'Tab 1',
      active: true,
      reviews: [buildDefaultReview()],
    },
  ],
});

export default {
  name: 'CardWithTabsBoxerSectionEditor',
  components: { UploadImage },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: getDefaultFields(),
    };
  },
  mounted() {
    const def = getDefaultFields();
    const extract = this.sectionEditor.sectionExtract || {};
    this.fields = {
      ...def,
      ...extract,
      settings: { ...def.settings, ...(extract.settings || {}) },
      containerPage: { ...def.containerPage, ...(extract.containerPage || {}) },
      titleCard: { ...def.titleCard, ...(extract.titleCard || {}) },
      listTabContent: { ...def.listTabContent, ...(extract.listTabContent || {}) },
      tabs:
        Array.isArray(extract.tabs) && extract.tabs.length
          ? extract.tabs.map((tab, index) => ({
              key: tab.key || `tab-${index + 1}`,
              label: tab.label || `Tab ${index + 1}`,
              active: !!tab.active,
              reviews:
                Array.isArray(tab.reviews) && tab.reviews.length
                  ? tab.reviews.map(review => ({
                      review: review.review || '',
                      avatar: review.avatar || '',
                      username: review.username || '',
                      verifiedShow: review.verifiedShow !== false,
                      verifiedIcon: review.verifiedIcon || DEFAULT_VERIFIED_ICON,
                      verifiedText: review.verifiedText || 'Verified Buyer',
                    }))
                  : [buildDefaultReview()],
            }))
          : def.tabs,
    };
    if (!this.fields.tabs.some(tab => tab.active) && this.fields.tabs.length) {
      this.fields.tabs[0].active = true;
    }
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionCardWithTabsBoxer(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
    genarateUniqueId() {
      return Math.random()
        .toString(36)
        .substring(2, 15);
    },
    handleAddTab() {
      this.fields.tabs.push({
        key: this.genarateUniqueId(),
        label: `Tab ${this.fields.tabs.length + 1}`,
        active: false,
        reviews: [buildDefaultReview()],
      });
    },
    handleRemoveTab(index) {
      if (this.fields.tabs.length <= 1) return;
      const wasActive = this.fields.tabs[index].active;
      this.fields.tabs.splice(index, 1);
      if (wasActive && this.fields.tabs.length) {
        this.fields.tabs[0].active = true;
      }
    },
    handleSetActiveTab(index) {
      this.fields.tabs.forEach((tab, i) => {
        tab.active = i === index;
      });
    },
    handleAddReview(tabIndex) {
      this.fields.tabs[tabIndex].reviews.push(buildDefaultReview());
    },
    handleRemoveReview(tabIndex, reviewIndex) {
      if (this.fields.tabs[tabIndex].reviews.length <= 1) return;
      this.fields.tabs[tabIndex].reviews.splice(reviewIndex, 1);
    },
    handleUploadAvatar(obj, tabIndex, reviewIndex) {
      this.fields.tabs[tabIndex].reviews[reviewIndex].avatar = obj.imageSrc;
    },
    handleRemoveAvatar(tabIndex, reviewIndex) {
      this.fields.tabs[tabIndex].reviews[reviewIndex].avatar = '';
    },
    handleUploadVerifiedIcon(obj, tabIndex, reviewIndex) {
      this.fields.tabs[tabIndex].reviews[reviewIndex].verifiedIcon = obj.imageSrc;
    },
    handleRemoveVerifiedIcon(tabIndex, reviewIndex) {
      this.fields.tabs[tabIndex].reviews[reviewIndex].verifiedIcon = '';
    },
    handleUploadBackgroundImage(obj) {
      this.fields.settings.backgroundImage = obj.imageSrc;
    },
    handleRemoveBackgroundImage() {
      this.fields.settings.backgroundImage = '';
    },
  },
};
</script>

<style lang="scss" scoped>
.group-item {
  border: 1px solid #0000000f;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 16px;
}
.ck-editor__editable_inline,
.ck-editor__editable {
  min-height: 180px;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
</style>
